function PageNotfound() {
  return (
    <div>
      <h1>Oups... Something went wrong, Page Not Found</h1>
    </div>
  );
}
export default PageNotfound;
